<template>
    <tailwind-layout title="Rental Payments">
        <div class="overflow-hidden h-[calc(100vh-280px)] flex items-center justify-center -mx-4 sm:-mx-6 lg:-mx-8">
            <div class="text-center px-4">
                <h2 class="text-2xl font-bold mb-4">
                    <!-- Change heading text based on invitation status -->
                    {{ landlord_invited ? 'Landlord Invitation Sent' : 'Invite Your Landlord' }}
                </h2>

                <p class="text-lg font-medium text-gray-900 mb-2">
                    <!-- Different subtext depending on invitation -->
                    <template v-if="landlord_invited">
                    Your landlord has been invited and will receive an email shortly.
                    </template>
                    <template v-else>
                    Your Landlord is not currently signed up to use the Rental Payments Portal.
                    </template>
                </p>

                <p class="text-lg font-medium text-gray-900 mb-8" v-if="!landlord_invited">
                    Click below to get started and make Rental Payments smoother for everyone!
                </p>

                <!-- Button changes if landlord already invited -->
                <button
                    type="button"
                    v-if="!landlord_invited"
                    @click="openLandlordInvitationPopup = true"
                    class="primaryButton"
                >
                    Invite Landlord
                </button>
                <button
                    v-else
                    type="button"
                    @click="resendInvitation"
                    class="primaryButton"
                >
                    Resend Invitation
                </button>
            </div>
        </div>

        <landlord-invitation-email :open="openLandlordInvitationPopup" :is_resend_invitation="isResendInvitation" @close="openLandlordInvitationPopup = false"></landlord-invitation-email>
    </tailwind-layout>
</template>

<script setup>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import LandlordInvitationEmail from '@/Shared/LandlordInvitationEmail.vue'
import { ref } from 'vue';

const openLandlordInvitationPopup = ref(false);
const isResendInvitation = ref(false);

const props = defineProps({
    landlord_invited: Object,
});

const resendInvitation = () => {
    isResendInvitation.value = true;
    openLandlordInvitationPopup.value = true;
};
</script>
